/* import __COLOCATED_TEMPLATE__ from './item.hbs'; */
import Component from '@ember/component';
export default Component.extend({
  tagName: 'a',
  classNames: ['prism-menu__item'],
  attributeBindings: ['href'],
  onClick() {},
  close: null,
  click() {
    if (this.close) {
      this.close();
    }
    this.onClick();
  }
});